import '@/installCompositionApi'

import hateoasIndex from '@/hateoas-index.js'
import http from '@/helpers/http'
import { mount } from '@/mounter'

import SanitasTherapistSearch from './SanitasTherapistSearch'

const config = window.Sanitas?.SanitasTherapistSearchConfig || {}

http.create({
  axiosConfig: {
    baseURL: '/',
  },
})
http.createHateoas({
  name: 'api',
  rootEndpoint: hateoasIndex,
  axiosConfig: {
    baseURL: config.apiUrl || '/public',
  },
})

mount('therapist-search', SanitasTherapistSearch, config)
